import React from 'react';
import ExecutiveDashboard from './ExecutiveDashboard';

const DashboardPage: React.FC = () => {
  return <ExecutiveDashboard />;
};

export default DashboardPage;
